export function formatDateWithTime(value: string): string {
  if (!value) return '';
  const match = /^(\d{2})\/(\d{2})\/(\d{4})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(value);
  if (match) {
    const [, day, month, year, hour, minute] = match;
    const base = `${day}/${month}/${year}`;
    return hour && minute ? `${base} ${hour}:${minute}` : base;
  }
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).replace(',', ' -');
}
